<template>
    <div class="home-sider">
        <img :src="src" alt="" :class="isCollapsed?'collapsed-style':''">
        <div class="user-name" v-show="!isCollapsed">谢思远</div>
        <p>
            <Icon type="logo-buffer" size="18" :class="isCollapsed?'collapsed-style':''" />
            <span>管理员</span>
        </p>
        <p>
            <Icon type="md-boat" size="18" :class="isCollapsed?'collapsed-style':''"/>
            <span>广东卓建律师事务所</span>
        </p>
    </div>
</template>
<script>
    export default {
        data () {
            return {
                src:'http://qn.dev.andunip.cn/1543226307000644.JPG?e=1543230411&token=5NnH-jZ-oC6RX7vvP9rHJxjdgaA9yjHdItFTSnf0:6kG7lkJNpjQN0kzfiFNwmzLa7lw='
            }
        },
        props: ['isCollapsed'],

        methods: {

        },
        created(){

        },
        beforeMount(){

        },
        mounted(){

        },
        updated(){

        },
        components: {

        },
        watch: {

        }
    }
</script>
<style lang="sass" scoped>
 @import './homeSider.scss';
</style>



// WEBPACK FOOTER //
// src/components/homeSider/homeSider.vue